<script lang="ts" setup>
import { getUserProjects } from '~/api/user';

const userStore = useUserStore();

onMounted(() => {
  if (window && window.ym && userStore.user) {
    window.ym(95948387, 'userParams', { id: userStore.user.id, email: userStore.user.email });
  }

  if (userStore.user && window && 'jivo_api' in window) {
    setTimeout(async () => {
      const user = userStore.user;
      if (!user) return;
      window.jivo_api.setContactInfo({
        name: user.name,
        email: user.email,
        phone: user.phone,
        description: `https://begemot.ai/nova/resources/users/${user.id}`,
      });

      const projects = await getUserProjects();
      const data = projects.slice(0, 10).map((p) => ({
        key: `#${p.id}`,
        link: `https://begemot.ai/projects/${p.id}`,
        title: p.title,
        content: p.payed_status ? `Оплачен: ${(p.services || []).join(',')}` : 'Не оплачен',
      }));
      window.jivo_api.setCustomData(data);
    }, 5000);
  }
});
</script>

<template>
  <span hidden />
</template>
